import gql from 'not-graphql-tag';

export const isEmailExistQuery = gql`
  query isEmailExist($newEmail: String) {
    isEmailExist(email: $newEmail) {
      exist
    }
  }
`;

export const updateEmailMutation = gql`
  mutation updateEmail($payload: ChangeEmailRequest!) {
    updateEmail(payload: $payload) {
      isSuccess
      reason
    }
  }
`;
